// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { arbitrumGoerli as _arbitrumGoerli } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the arbitrumGoerli chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 421613
 * Chain Name: Arbitrum Goerli
 * Default Block Explorer: https://goerli.arbiscan.io
 * Default RPC URL: https://goerli-rollup.arbitrum.io/rpc
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { arbitrumGoerli } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: arbitrumGoerli,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const arbitrumGoerli = createCommon({
	..._arbitrumGoerli,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
